import React, { Component } from 'react';
import ShortList from './shortList'




const styles = {
    realStyle:{
        marginLeft: "70px",
        marginTop: "10px",
        border: "1px solid #ccc",
        width: "72%",
        minHeight: "80px",
        padding: "10px",
        fontFamily: "Helvetica, arial, sans-serif",
        fontSize: "12px",
        lineHeight: "18px",
        borderRadius: "5px",
        backgroundColor: "white",
        overflow: "hidden"
        
    },
    angleStyle:{
        fontSize: "20px",
        color: "grey",
        float: "right",
        padding: "20px"

    }
}
class RealTime extends Component{
    render(){
        const { realStyle, angleStyle } = styles;
        return(
            <section style={realStyle}>
                <i className="fas fa-angle-down" style={angleStyle}/>
                 <ShortList favourites={this.props.favourites}
                 addFavourites={this.props.addFavourites}/>
            </section>
        )
    }
};

export default RealTime;


// WEBPACK FOOTER //
// ./src/components/mainpage/box/RealTime.js